import * as React from "react";
import { IdStyles } from "../../less/IdStyles";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { IdBadgePosition } from "../generic/badge/IdBadgePosition";
import { IconWithModifier } from "../generic/icon-with-modifier/IconWithModifier";
import { IdIcon } from "../generic/icon/IdIcon";
import { NumberFormat } from "../generic/number-format/NumberFormat";
import { TypeNumberFormat } from "../generic/number-format/TypeNumberFormat";
import { TextLoca } from "../generic/text/TextLoca";
export var ImprovementEffectsMaxLevel = function (_a) {
    var item = _a.item;
    var icon = item.icon, locaKey = item.locaKey, currentBonus = item.currentBonus;
    var modifierIconProps = {
        icon: IdIcon.PlusResearchIcn,
        position: IdBadgePosition.BottomLeft,
        styleId: IdStyles.IconSmall,
    };
    return (React.createElement("div", { className: "improvement__effects" },
        React.createElement("div", { className: "flex flex--stacked flex--guts" },
            React.createElement(TextLoca, { id: IdLoca.currentBonus, className: IdStyles.TextNormal }),
            React.createElement("div", { className: "flex flex--guts" },
                React.createElement(IconWithModifier, { styleId: IdStyles.IconMedium, icon: icon, modifierIconProps: modifierIconProps, tooltipLoca: locaKey }),
                React.createElement(NumberFormat, { amount: currentBonus, format: TypeNumberFormat.Add, className: IdStyles.TextPositive })))));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/improvement/ImprovementEffectsMaxLevel.tsx
// module id = 2690
// module chunks = 3